import { Stack, Typography } from '@mui/material';
import { ResultRow } from './ResultRow';

export function NeglectTest({ testDetails }) {
  const formattedValue = () => {
    if (!testDetails?.neglectTestValid) {
      return 'Cannot determine';
    }
    return testDetails.neglectDetected ? 'YES' : 'NO';
  };

  return (
    <>
      <Stack>
        <ResultRow title="Neglect Detected" value={formattedValue()} />
        {testDetails?.neglectResponse && (
          <Typography variant="h6" color="textPrimary" component="h6">
            Patient Answer: {testDetails?.neglectResponse}
          </Typography>
        )}
      </Stack>
    </>
  );
}
